import React, { Component } from 'react'
import { Container } from '@sencha/ext-modern'
import Message from '../../components/Message'
import SearchBar from './SearchBar'
import ListItem from './ListItem'
import FlowRecordSelectDiv from './FlowRecordSelectDiv'

Ext.require([
    'Ext.dataview.listswiper.ListSwiper',
    'Ext.MessageBox'
])
const style = {
    outer: {
        backgroundColor: "#f5f5f5",
        paddingTop: "10px",
        paddingBottom: "10px"
    }
}
class FlowRecordTask extends Component {
    state = {
        query: '',
        loading: false,
        errorMessage: null,
        selectedStatus: 0,
        flowRecordList: null,
        pageCount: 10,
        page: 1,
        totalCount: 0
    }

    componentDidMount() {
        const { pageCount } = this.state
        this.GetFlowRecordList(pageCount)
    }

    GetFlowRecordList = (row) => {
        const { query, selectedStatus } = this.state
        const { match: { params: { type } } } = this.props
        Tyan.doPostEvent('GetFlowRecordList', {
            data: { type, status: selectedStatus, row, query, },
            onRequest: () => {
                this.setState({ loading: true })
            },
            onEnd: ({ errorMessage, flowRecordList, totalCount }) => {
                if (errorMessage) {
                    this.setState({ errorMessage })
                    return
                }
                this.setState({ loading: false, flowRecordList, totalCount })
            }
        })
    }

    handleLoadMore = () => {
        let { page, pageCount } = this.state
        page += 1
        this.GetFlowRecordList(pageCount * page)
        this.setState({ page })
    }

    handleChange = (field, value) => {
        this.setState({ query: value })
    }

    handleSearch = () => {
        const { pageCount } = this.state
        this.GetFlowRecordList(pageCount)
    }

    handleAdd = ({ showDetail }) => {
        const { match: { params: { type } } } = this.props
        Tyan.pubForm.showDialog('核签表单选择', props => <FlowRecordSelectDiv showDetail={showDetail} {...props} type={type} weixin={true} />)
    }

    handleSelectStatus = (e) => {
        this.setState({ selectedStatus: e.value })
        const { pageCount } = this.state
        this.GetFlowRecordList(pageCount)
    }

    handleChildTap = ({ id }) => {
        const { selectedStatus } = this.state
        location.hash = `/QYWX/FlowRecordDetail/${id}/0/${selectedStatus}`
    }

    render() {
        const { flowRecordList, errorMessage, query, selectedStatus, totalCount } = this.state
        if (errorMessage) {
            return <Message text="数据加载失败" subText={errorMessage} />
        } else if (!flowRecordList) {
            return <Message text="数据加载中..." />
        }

        return (
            <Container layout={{ type: "vbox" }} style={style.outer} scrollable >
                <SearchBar selectedStatus={selectedStatus} statusList={[['申请中', 1], ['签核中', 2]]} handleChange={this.handleChange} handleSearch={this.handleSearch} query={query} handleSelectStatus={this.handleSelectStatus} handleAdd={this.handleAdd} />
                <ListItem listData={flowRecordList} totalCount={totalCount} handleLoadMore={this.handleLoadMore} handleChildTap={this.handleChildTap} />
            </Container>
        )
    }
}
export default FlowRecordTask